// Canonical Beta Feedback PDF filename — MUST match the server's
// `build_beta_feedback_pdf_filename` in /app/backend/beta_feedback.py.
//
// Format:
//   Beta Feedback Report - <Name> - YYYY-MM-DD.pdf
//
// Sanitisation rules mirror the backend:
//   • strip Windows/macOS/Linux-forbidden chars: < > : " / \ | ? *
//     and NUL, but PRESERVE accented letters + hyphens + spaces
//   • collapse whitespace runs to a single space
//   • trim trailing "." and " " which some OSes silently strip
//   • fall back to "Beta Tester" when nothing usable remains
//   • cap name segment at 80 chars

// eslint-disable-next-line no-control-regex
const FORBIDDEN_RE = /[<>:"/\\|?*\u0000]/g;

export function sanitiseDisplayName(name) {
  if (!name) return "Beta Tester";
  let cleaned = String(name).replace(FORBIDDEN_RE, "");
  // Strip control chars (0x00-0x1F, 0x7F) while keeping unicode.
  // eslint-disable-next-line no-control-regex
  cleaned = cleaned.replace(/[\u0000-\u001F\u007F]/g, "");
  cleaned = cleaned.split(/\s+/).filter(Boolean).join(" ");
  cleaned = cleaned.replace(/[. ]+$/g, "");
  if (cleaned.length > 80) cleaned = cleaned.slice(0, 80).trimEnd();
  return cleaned || "Beta Tester";
}

export function submittedYMD(submittedAt) {
  if (typeof submittedAt === "string" && submittedAt) {
    // Prefer the fast prefix slice — every server-written submitted_at
    // is ISO-8601 UTC, so the first 10 chars are `YYYY-MM-DD`.
    const head = submittedAt.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(head)) return head;
    // Otherwise let the Date constructor normalise (browser TZ-aware
    // in only a few edge cases — best-effort).
    const d = new Date(submittedAt);
    if (!Number.isNaN(d.getTime())) {
      return d.toISOString().slice(0, 10);
    }
  }
  return new Date().toISOString().slice(0, 10);
}

export function buildBetaFeedbackFilename(displayName, submittedAt) {
  return `Beta Feedback Report - ${sanitiseDisplayName(displayName)} - ${submittedYMD(submittedAt)}.pdf`;
}
